<template lang='pug'>
div
    UHFSensorSelectorLinks
    div.fullwidth(v-if="$route.params.lang == 'en'")

        section.title-container
            h1.product-title UHF-DVS-25 
            h2.product-subtitle Oil Valve Sensor for Installation at DN25 / DN40 or 1" / 1.5" Oil Valves

        section.margin-bottom
            .column-container
                .column.center-content
                    picture.main-product-picture
                        source(type='image/webp', srcset='@/assets/photos/UHF-DVS-25.webp')
                        img( src='@/assets/photos/UHF-DVS-25.png', width="100%", alt='UHF PD Sensor UHF-DVS-25', title='UHF PD Sensor UHF-DVS-25')
                .column.factsandbluebox
                    .factbox
                        span.headline Key Features:
                        ul
                            li Retrofit possible at straight opening oil valves with min. diameter 25 mm
                            li Bandwidth: 100 MHz ... 3 GHz
                            li For oil-filled transformers
                            li Integrated high-pass filter
                            li Antenna fully retractable
                    .bluebox
                        Downloadlink(text='Datasheet (pdf, english)', link="/pdf/Datasheet UHF-DVS-25.pdf")
                        Maillink(to='support@bss-hs.de', sub='UHF-1"/1.5"', text='Contact Us', size=30, strokeWidth=2)
                        Sitelink(to="/en/products/pdm-600", text='UHF PD Monitoring System PDM-600')
                        Sitelink(to="/en/products/PDM-600-Mobile", text='PDM-600-Mobile')
                        Sitelink(to="/en/products/pdaccessories/overview", text='PD Accessories')
                    
        section.margin-bottom
            p The sensor is used for the decoupling of electromagnetic PD signals from the inside of transformers. The sensor is designed for retrofit of transformers with DN25 / DN40 or 1“ / 1½“ oil valves.


    div.fullwidth(v-if="$route.params.lang == 'de'")

        section.title-container
            h1.product-title UHF-DVS-25
            h2.product-subtitle Schiebesensor für die Installation an DN25 / DN40 oder 1" / 1,5" Ölschiebern

        section.margin-bottom
            .column-container
                .column.center-content
                    picture.main-product-picture
                        source(type='image/webp', srcset='@/assets/photos/UHF-DVS-25.webp')
                        img( src='@/assets/photos/UHF-DVS-25.png', width="100%", alt='UHF-TE-Sensor UHF-DVS-25', title='UHF-TE-Sensor UHF-DVS-25')
                .column.factsandbluebox
                    .factbox
                        span.headline Highlights:
                        ul
                            li Installation an vorhandenen DN25 / DN40 oder 1“ / 1½“ Schiebern
                            li Bandwidth: 100 MHz ... 3 GHz
                            li Für ölgefüllte Transformatoren
                            li Integrierter Hochpassfilter
                            li Sensorkopf vollständig zurückziehbar
                    .bluebox
                        Downloadlink(text='Datenblatt (pdf, englisch)', link="/pdf/Datasheet UHF-DVS-25.pdf")
                        Maillink(to='support@bss-hs.de', sub='UHF-1"/1.5"', text='Kontakt', size=30, strokeWidth=2)
                        Sitelink(to="/de/products/pdm-600", text='UHF-TE-Monitoringsystem PDM-600')
                        Sitelink(to="/de/products/PDM-600-Mobile", text='PDM-600-Mobile')
                        Sitelink(to="/de/products/pdaccessories/overview", text='TE-Zubehör')

        section.margin-bottom
            p Der Sensor wird verwendet, um elektromagnetische TE-Impulse aus dem Inneren von Transformatoren auszukoppeln. Der Sensor ist für die nachträgliche Installation an standardisierten Flachkeilschiebern (DN25 / DN40 sowie 1“ / 1½“) entwickelt

</template>

<script>
export default {
    meta: {
        de: {
            title: 'BSS | UHF-DVS-25"',
            description:
                'Schiebesensor für die Installation an DN25 / DN40 oder 1" / 1,5" Ölschiebern',
        },
        en: {
            title: 'BSS | UHF-DVS-25"',
            description:
                'Oil Valve Sensor for Installation at DN25 / DN40 or 1" / 1.5" Oil Valves',
        },
    },
};
</script>